// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
// GENERAL NUEVO EMPLEO, FORMACIÓN Y RECURSO
// ----------------------------------------------------------------------------- */
.creacion-ofertas p{ margin-bottom: 0px; }

.creacion-ofertas .cabecera{ align-items: flex-end; }

.creacion-ofertas .fechas-inscripcion{ gap: 10px; }
.creacion-ofertas .noticias-destacadas{ gap: 5px; }

input[type="date"]::-webkit-calendar-picker-indicator { margin-left: -15px; }

.creacion-ofertas .textareas{gap: 5%;}
.creacion-ofertas .formulario-alta .campo select{padding-top: 0px; }

.creacion-ofertas .flex-1 .campo{flex: 1 1;}

.formulario-alta  .campo input,
  .formulario-alta  .campo select{
      border: none;
      border-bottom: 1px solid #007932;
      padding: 5px 8px 1px 8px;
  }

  .formulario-alta  .campo textarea {
      resize: vertical;
      min-height: 160px;
      border: 1px solid #007932;
      border-radius: 10px;
      margin-top: 10px;
      padding: 16px 20px;
  }

  .formulario-alta .campo select,
  .formulario-alta .campo input[type="date"] 
  { color: black;}

  .formulario-alta .formulario-cv .fecha-fin{ 
      gap: 15px; 
      color: black;
  }

/* Placeholder styles for form inputs and textareas */
.creacion-ofertas .formulario-alta input::placeholder,
.creacion-ofertas .formulario-alta textarea::placeholder {
  color: #999999 !important;
  opacity: 1;
}

/* Placeholder styles for all other inputs and textareas in creacion-ofertas */
.creacion-ofertas input::placeholder,
.creacion-ofertas textarea::placeholder {
  color: #999999 !important;
  opacity: 1;
}

/* -----------------------------------------------------------------------------
// GENERAL NUEVO RECURSO SOCIAL
// ----------------------------------------------------------------------------- */

/* -----------------------------------------------------------------------------
// GENERAL NUEVO FORMACIÓN
// ----------------------------------------------------------------------------- */
.creacion-ofertas .datos-generales{ width: calc(100% - 550px); } 
.creacion-ofertas .datos-generales .centro{ width: calc(100% - 370px); } 

/* -----------------------------------------------------------------------------
// UPLOAD FOTO COMPONENT
// ----------------------------------------------------------------------------- */
.upload-foto {
  margin-top: 10px;
}

.upload-area {
  border: 2px dashed #007932;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.upload-area:hover {
  background-color: #e9ecef;
  border-color: #005a24;
}

.upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #007932;
  font-weight: 500;
}

.upload-icon {
  font-size: 2rem;
  color: #007932;
}

.upload-label span {
  font-size: 1.1rem;
}

.upload-label small {
  color: #6c757d;
  font-size: 0.9rem;
}

.preview-foto {
  position: relative;
  display: inline-block;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.foto-preview {
  width: 100%;
  max-width: 300px;
  height: 200px;
  object-fit: cover;
  display: block;
}

.eliminar-foto {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  padding: 0px !Important;
  height: 35px;
  min-width: 35px;
  max-width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.eliminar-foto:hover {
  background-color: #c82333;
}

.eliminar-foto svg {
  font-size: 0.9rem;
}

/* -----------------------------------------------------------------------------
// GENERAL NUEVO RECURSO
// ----------------------------------------------------------------------------- */
.creacion-ofertas .info-recurso{ width: calc(100% - 550px); }

.area-verde {
  height: 150px;
  background-color: #D0FDD7;
  border: 2px dashed #007932;
  border-radius: 10px;
  justify-content: center;
  margin: 0 auto;
  text-align: center;
}

.area-verde p { margin: 0px 20px; }

.documentos .subir-documento button {
  display: block;
  margin: 20px auto;
}

.creacion-ofertas .archivo button{
  display: block;
  margin: 0 auto;
  width: fit-content;
}


.categorias-sociales .checkbox{ gap: 5px 50px;}

/* -----------------------------------------------------------------------------
// BOTONES CANCELAR - CREAR
// ----------------------------------------------------------------------------- */
.creacion-ofertas .botones{gap: 10px;}

.creacion-ofertas button{
    width: 350px;
    border: none;
    padding: 10px 50px;
    border-radius: 25px;
    text-align: center;
}

.creacion-ofertas button:hover{background-color: black;}


/* -----------------------------------------------------------------------------
// VENTANA SEGURO QUE QUIERES CANCELAR
// ----------------------------------------------------------------------------- */
.ventana-cancelar {
  position: fixed;
  top: 50%; /* Ajusta la posición arriba de la sección de botones */
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 50vh 20px;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ventana-cancelar .botones { margin: 15px auto; }

.ventana-cancelar .botones button {
  padding: 10px 25px;
  border: none;
  cursor: pointer;
  border-radius: 25px;
}

.ventana-cancelar .botones button:hover {
  background-color: black;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/NuevoEmpleo.css"],"names":[],"mappings":"AAAA;;kFAEkF;AAClF,qBAAqB,kBAAkB,EAAE;;AAEzC,6BAA6B,qBAAqB,EAAE;;AAEpD,uCAAuC,SAAS,EAAE;AAClD,wCAAwC,QAAQ,EAAE;;AAElD,wDAAwD,kBAAkB,EAAE;;AAE5E,6BAA6B,OAAO,CAAC;AACrC,iDAAiD,gBAAgB,EAAE;;AAEnE,iCAAiC,SAAO,CAAC;;AAEzC;;MAEM,YAAY;MACZ,gCAAgC;MAChC,wBAAwB;EAC5B;;EAEA;MACI,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;EACtB;;EAEA;;IAEE,YAAY,CAAC;;EAEf;MACI,SAAS;MACT,YAAY;EAChB;;AAEF,qDAAqD;AACrD;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;kFAEkF;;AAElF;;kFAEkF;AAClF,oCAAoC,yBAAyB,EAAE;AAC/D,4CAA4C,yBAAyB,EAAE;;AAEvE;;kFAEkF;AAClF;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;kFAEkF;AAClF,iCAAiC,yBAAyB,EAAE;;AAE5D;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;;AAGA,gCAAgC,aAAa,CAAC;;AAE9C;;kFAEkF;AAClF,2BAA2B,SAAS,CAAC;;AAErC;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,+BAA+B,uBAAuB,CAAC;;;AAGvD;;kFAEkF;AAClF;EACE,eAAe;EACf,QAAQ,EAAE,uDAAuD;EACjE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6BAA6B,iBAAiB,EAAE;;AAEhD;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* -----------------------------------------------------------------------------\n// GENERAL NUEVO EMPLEO, FORMACIÓN Y RECURSO\n// ----------------------------------------------------------------------------- */\n.creacion-ofertas p{ margin-bottom: 0px; }\n\n.creacion-ofertas .cabecera{ align-items: flex-end; }\n\n.creacion-ofertas .fechas-inscripcion{ gap: 10px; }\n.creacion-ofertas .noticias-destacadas{ gap: 5px; }\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator { margin-left: -15px; }\n\n.creacion-ofertas .textareas{gap: 5%;}\n.creacion-ofertas .formulario-alta .campo select{padding-top: 0px; }\n\n.creacion-ofertas .flex-1 .campo{flex: 1;}\n\n.formulario-alta  .campo input,\n  .formulario-alta  .campo select{\n      border: none;\n      border-bottom: 1px solid #007932;\n      padding: 5px 8px 1px 8px;\n  }\n\n  .formulario-alta  .campo textarea {\n      resize: vertical;\n      min-height: 160px;\n      border: 1px solid #007932;\n      border-radius: 10px;\n      margin-top: 10px;\n      padding: 16px 20px;\n  }\n\n  .formulario-alta .campo select,\n  .formulario-alta .campo input[type=\"date\"] \n  { color: black;}\n\n  .formulario-alta .formulario-cv .fecha-fin{ \n      gap: 15px; \n      color: black;\n  }\n\n/* Placeholder styles for form inputs and textareas */\n.creacion-ofertas .formulario-alta input::placeholder,\n.creacion-ofertas .formulario-alta textarea::placeholder {\n  color: #999999 !important;\n  opacity: 1;\n}\n\n/* Placeholder styles for all other inputs and textareas in creacion-ofertas */\n.creacion-ofertas input::placeholder,\n.creacion-ofertas textarea::placeholder {\n  color: #999999 !important;\n  opacity: 1;\n}\n\n/* -----------------------------------------------------------------------------\n// GENERAL NUEVO RECURSO SOCIAL\n// ----------------------------------------------------------------------------- */\n\n/* -----------------------------------------------------------------------------\n// GENERAL NUEVO FORMACIÓN\n// ----------------------------------------------------------------------------- */\n.creacion-ofertas .datos-generales{ width: calc(100% - 550px); } \n.creacion-ofertas .datos-generales .centro{ width: calc(100% - 370px); } \n\n/* -----------------------------------------------------------------------------\n// UPLOAD FOTO COMPONENT\n// ----------------------------------------------------------------------------- */\n.upload-foto {\n  margin-top: 10px;\n}\n\n.upload-area {\n  border: 2px dashed #007932;\n  border-radius: 10px;\n  padding: 30px;\n  text-align: center;\n  background-color: #f8f9fa;\n  transition: all 0.3s ease;\n}\n\n.upload-area:hover {\n  background-color: #e9ecef;\n  border-color: #005a24;\n}\n\n.upload-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  color: #007932;\n  font-weight: 500;\n}\n\n.upload-icon {\n  font-size: 2rem;\n  color: #007932;\n}\n\n.upload-label span {\n  font-size: 1.1rem;\n}\n\n.upload-label small {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.preview-foto {\n  position: relative;\n  display: inline-block;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.foto-preview {\n  width: 100%;\n  max-width: 300px;\n  height: 200px;\n  object-fit: cover;\n  display: block;\n}\n\n.eliminar-foto {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 35px;\n  padding: 0px !Important;\n  height: 35px;\n  min-width: 35px;\n  max-width: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.eliminar-foto:hover {\n  background-color: #c82333;\n}\n\n.eliminar-foto svg {\n  font-size: 0.9rem;\n}\n\n/* -----------------------------------------------------------------------------\n// GENERAL NUEVO RECURSO\n// ----------------------------------------------------------------------------- */\n.creacion-ofertas .info-recurso{ width: calc(100% - 550px); }\n\n.area-verde {\n  height: 150px;\n  background-color: #D0FDD7;\n  border: 2px dashed #007932;\n  border-radius: 10px;\n  justify-content: center;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.area-verde p { margin: 0px 20px; }\n\n.documentos .subir-documento button {\n  display: block;\n  margin: 20px auto;\n}\n\n.creacion-ofertas .archivo button{\n  display: block;\n  margin: 0 auto;\n  width: fit-content;\n}\n\n\n.categorias-sociales .checkbox{ gap: 5px 50px;}\n\n/* -----------------------------------------------------------------------------\n// BOTONES CANCELAR - CREAR\n// ----------------------------------------------------------------------------- */\n.creacion-ofertas .botones{gap: 10px;}\n\n.creacion-ofertas button{\n    width: 350px;\n    border: none;\n    padding: 10px 50px;\n    border-radius: 25px;\n    text-align: center;\n}\n\n.creacion-ofertas button:hover{background-color: black;}\n\n\n/* -----------------------------------------------------------------------------\n// VENTANA SEGURO QUE QUIERES CANCELAR\n// ----------------------------------------------------------------------------- */\n.ventana-cancelar {\n  position: fixed;\n  top: 50%; /* Ajusta la posición arriba de la sección de botones */\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 50vh 20px;\n  border-radius: 8px;\n  text-align: center;\n  width: 100%;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ventana-cancelar .botones { margin: 15px auto; }\n\n.ventana-cancelar .botones button {\n  padding: 10px 25px;\n  border: none;\n  cursor: pointer;\n  border-radius: 25px;\n}\n\n.ventana-cancelar .botones button:hover {\n  background-color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
